import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=599dadf0"
import script from "./ChangeDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&id=599dadf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports